import { useTranslation } from "@/hooks/useTranslation";
import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogScrollableArea,
	Icon,
	Typography,
} from "@st-marketplace/ui";
import type { FC } from "react";

export interface ImportWarningDialogProps {
	open: boolean;
	onClose: () => void;
	onContinue: () => void;
}

const ImportWarningDialog: FC<ImportWarningDialogProps> = ({
	open,
	onClose,
	onContinue,
}) => {
	const { t } = useTranslation();

	return (
		<Dialog open={open} onOpenChange={(o) => !o && onClose()}>
			<DialogContent className="w-full max-w-xl">
				<DialogHeader>
					<div className="flex items-center gap-2">
						<Icon name="error-warning-line" className="text-warning-text" />
						<Typography variant="title-sm" className="text-warning-text">
							{t("common.csv.importWarningTitle")}
						</Typography>
					</div>
				</DialogHeader>

				<DialogScrollableArea className="max-h-[90vh]">
					<Typography
						variant="body-md"
						className="mb-8 text-secondary-text-100"
					>
						{t("common.csv.importWarningContent")}
					</Typography>

					<Typography variant="title-sm">
						{t("common.csv.importWarningSure")}
					</Typography>
				</DialogScrollableArea>
				<DialogFooter
					buttons={{
						primary: {
							label: t("common.csv.importWarningButtonContinue"),
							props: { onClick: onContinue },
						},
						secondary: {
							label: t("common.csv.importWarningButtonCancel"),
							props: { onClick: onClose },
						},
					}}
				/>
			</DialogContent>
		</Dialog>
	);
};

export default ImportWarningDialog;
